var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAuthenticated
    ? _c("footer", [
        _c(
          "nav",
          { staticClass: "smile-header-nav-mobile" },
          [
            _c("router-link", { attrs: { to: { path: "/" } } }, [
              _c("div", { staticClass: "smile-mobile-menu-image" }, [
                _c("img", {
                  class: {
                    "smile-mobile-menu-image-selected": _vm.isExactActive(
                      "home"
                    )
                  },
                  attrs: {
                    src: require("@/assets/images/home.svg"),
                    alt: "Αρχική Σελίδα"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "smile-mobile-menu-text" }, [
                _vm._v("\n        Αρχική\n      ")
              ])
            ]),
            _vm._v(" "),
            _c("router-link", { attrs: { to: { path: "/loyalty-card" } } }, [
              _c("div", { staticClass: "smile-mobile-menu-image" }, [
                _c("img", {
                  class: {
                    "smile-mobile-menu-image-selected": _vm.isExactActive(
                      "loyalty-card"
                    )
                  },
                  attrs: {
                    src: require("@/assets/images/credit-card.svg"),
                    alt: "Smile κάρτα"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "smile-mobile-menu-text" }, [
                _vm._v("\n        Κάρτα\n      ")
              ])
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                class: _vm.exactActiveClass("invoices"),
                attrs: { to: { path: "/invoices" } }
              },
              [
                _c("div", { staticClass: "smile-mobile-menu-image" }, [
                  _c("img", {
                    class: {
                      "smile-mobile-menu-image-selected": _vm.isExactActive(
                        "invoices"
                      )
                    },
                    attrs: {
                      src: require("@/assets/images/istoriko.svg"),
                      alt: "Ιστορικό Αγορών"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "smile-mobile-menu-text" }, [
                  _vm._v("\n        Ιστορικό\n      ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                class: _vm.exactActiveClass("points"),
                attrs: { to: { path: "/points" } }
              },
              [
                _c("div", { staticClass: "smile-mobile-menu-image" }, [
                  _c("img", {
                    class: {
                      "smile-mobile-menu-image-selected": _vm.isExactActive(
                        "points"
                      )
                    },
                    attrs: {
                      src: require("@/assets/images/simeia.svg"),
                      alt: "Τα Σημεία Μας"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "smile-mobile-menu-text" }, [
                  _vm._v("\n        Σημεία\n      ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                class: _vm.exactActiveClass("account"),
                attrs: { to: { path: "/account" } }
              },
              [
                _c("div", { staticClass: "smile-mobile-menu-image" }, [
                  _c("img", {
                    class: {
                      "smile-mobile-menu-image-selected": _vm.isExactActive(
                        "account"
                      )
                    },
                    attrs: {
                      src: require("@/assets/images/profile.svg"),
                      alt: "Το Προφίλ Μου"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "smile-mobile-menu-text" }, [
                  _vm._v("\n        Προφίλ\n      ")
                ])
              ]
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdb56dc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdb56dc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","b-avatar":"src","b-img":"src","b-img-lazy":["src","blank-src"],"b-card":"img-src","b-card-img":"src","b-card-img-lazy":["src","blank-src"],"b-carousel-slide":"img-src","b-embed":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = null
// module chunks = 